export default {
    hangupButton: {
        fr: 'Terminer la téléconsultation',
        en: 'Finish the teleconsultation',
    },
};
